import { Location, KENYA_COUNTIES } from './locations';

export interface CountryConfig {
  code: string;
  name: string;
  flag: string;
  currency: string;
  currencySymbol: string;
  phonePrefix: string;
  regions: Location[];
  supportWhatsApp: string;
  supportPhone: string;
  supportEmail: string;
  tagline: string;
}

export const COUNTRIES: CountryConfig[] = [
  {
    code: 'KE',
    name: 'Kenya',
    flag: '🇰🇪',
    currency: 'KES',
    currencySymbol: 'KSh',
    phonePrefix: '+254',
    regions: KENYA_COUNTIES,
    supportWhatsApp: '',
    supportPhone: '',
    supportEmail: 'support@pambo.biz',
    tagline:
      'High-trust marketplace infrastructure for Kenya. Empowering trade through verified connections and secure digital commerce.',
  },
];
